import { motion } from 'motion/react';

// The Embrace mark (brand/logo/clairo-mark.svg): an open arc around a point of light. Theme
// aware: the arc uses the primary colour, the light the accent. `draw` animates the arc in.

export const ARC_PATH = 'M49.85 17.15 A21 21 0 1 0 49.85 46.85';

export function LogoMark({
  size = 32,
  draw = false,
  className,
}: {
  size?: number;
  draw?: boolean;
  className?: string;
}) {
  return (
    <svg viewBox="9 6 46 52" width={size} height={size} className={className} aria-hidden="true">
      <motion.path
        d={ARC_PATH}
        fill="none"
        strokeWidth={10}
        strokeLinecap="round"
        stroke="var(--primary)"
        initial={draw ? { pathLength: 0 } : false}
        animate={{ pathLength: 1 }}
        transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
      />
      <motion.circle
        cx={37}
        cy={32}
        r={6.5}
        fill="var(--accent)"
        initial={draw ? { scale: 0, opacity: 0 } : false}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: draw ? 0.7 : 0, type: 'spring', stiffness: 380, damping: 16 }}
        style={{ transformOrigin: '37px 32px' }}
      />
    </svg>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={`font-display text-lg tracking-tight text-text ${className ?? ''}`}>
      <span className="font-extrabold">Clairo</span>
      <span className="font-medium">Health</span>
    </span>
  );
}
